"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var AppsOutlined_1 = __importDefault(require("@mui/icons-material/AppsOutlined"));
var useAppSelector_1 = __importDefault(require("./useAppSelector"));
var AppSelector = function (_a) {
    var apps = _a.apps;
    var buttonRef = (0, react_1.useRef)(null);
    var _b = (0, useAppSelector_1.default)(buttonRef.current, apps), element = _b.element, open = _b.open;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IconButton_1.default, { ref: buttonRef, onClick: open, color: "inherit" },
            react_1.default.createElement(AppsOutlined_1.default, null)),
        element));
};
exports.default = AppSelector;
